import { GenAddressFormConfig } from "../models/address-details.model";
import { GenInputType } from "../enums/input-type.enum";
import { GenAsyncValidation } from "../enums/async-validation.enum";
import { validateEmail } from "../shared/validators/validate-email";

export const formConfig: GenAddressFormConfig[] = [
  {
    items: [
      {
        label: 'checkoutAddress.detailsForm.poNumber',
        formControlName: 'purchaseOrderNumber',
        placeholder: 'checkoutAddress.detailsForm.poNumberPlaceholder',
        value: '',
        type: GenInputType.TEXT,
        maxLength: 35,
        isRequired: true,
        id: 'purchaseOrderNumber'
      }
    ]
  },
];

export const renewalConfig: GenAddressFormConfig[] = [
  {
    items: [
      {
        formControlName: 'entryNumber',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'materialNumber',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'type',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'id',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'email',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'subEndDate',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'customerNbr',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
    ]
  },
  {
    items: [
      {
        label: 'checkoutAddress.detailsForm.firstName',
        formControlName: 'firstName',
        placeholder: 'checkoutAddress.detailsForm.firstNamePowerPlaySellingPlaceholder',
        value: '',
        type: GenInputType.TEXT,
        isRequired: true
      },
      {
        label: 'checkoutAddress.detailsForm.lastName',
        formControlName: 'lastName',
        placeholder: 'checkoutAddress.detailsForm.lastNamePowerPlaySellingPlaceholder',
        value: '',
        type: GenInputType.TEXT,
        isRequired: true
      },
    ]
  },
  {
    items: [
      {
        formControlName: 'subscriptionId',
        value: null,
        type: GenInputType.SELECT,
        isRequired: true
      }
    ]
  }
];

export const sellingConfig: GenAddressFormConfig[] = [
  {
    items: [
      {
        formControlName: 'entryNumber',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'materialNumber',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'type',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
      {
        formControlName: 'id',
        value: '',
        type: GenInputType.TEXT,
        isRequired: false,
        hidden: true,
      },
    ]
  },
  {
    items: [
      {
        label: 'checkoutAddress.detailsForm.firstName',
        formControlName: 'firstName',
        placeholder: 'checkoutAddress.detailsForm.firstNamePowerPlaySellingPlaceholder',
        value: '',
        type: GenInputType.TEXT,
        isRequired: true
      },
      {
        label: 'checkoutAddress.detailsForm.lastName',
        formControlName: 'lastName',
        placeholder: 'checkoutAddress.detailsForm.lastNamePowerPlaySellingPlaceholder',
        value: '',
        type: GenInputType.TEXT,
        isRequired: true
      },
    ]
  },
  {
    items: [
      {
        label: 'checkoutAddress.detailsForm.role',
        formControlName: 'userRole',
        placeholder: 'checkoutAddress.detailsForm.rolePlaceholder',
        value: null,
        type: GenInputType.SELECT,
        isRequired: true
      },
      {
        label: 'checkoutAddress.detailsForm.email',
        formControlName: 'email',
        placeholder: 'checkoutAddress.detailsForm.emailPlaceholder',
        value: '',
        type: GenInputType.TEXT,
        isRequired: true,
        validators: [validateEmail],
        asyncValidator: GenAsyncValidation?.Email
      },
    ]
  }
];
